import { Link, useParams } from "react-router-dom";
import Button from "@/common/components/Button";
import useUser from "@/common/hooks/useUser";
import UserData from "@/common/components/UserData";
import Tabs from "@/common/components/Tabs";
import LogRequestsTable from "@/common/components/LogRequestsTable";
import GoBackButton from "@/common/components/GoBackButton";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";

const Show = () => {
  const { id } = useParams();

  const {
    data: user,
    error: userError = {} as any,
    refetch: refetchUser,
  } = useUser({ id: id || '' });

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-64px)]"
      statusCode={userError?.status}
      refetchFunction={refetchUser}
    >
      <div>
        <div className="flex justify-between items-center mb-6">
          <div className="flex gap-4 items-center">
            <GoBackButton
              fallback="/users"
              searchLastRouteFromReference={`/users/${id}`}
            />

            <h2 className="text-2xl font-bold">{user?.full_name || ''}</h2>
          </div>

          <div className="flex gap-4">
            <Link to={`/users/${id}/edit`}>
              <Button name="update_user" className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
                Editar
              </Button>
            </Link>
          </div>
        </div>

        <Tabs
          tabsListClassName="w-full bg-transparent rounded-none"
          tabsTriggerClassName="h-8 w-full rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
          tabsContentClassName="mt-6"
          tabsList={[
            {
              label: 'Dados',
              value: '',
              body: (
                <UserData user={user} />
              )
            },
            {
              label: 'Histórico de ações',
              value: 'actionsHistory',
              disabled: !user?.id,
              body: (
                <>
                  {user && <LogRequestsTable type="AdminUser" id={user.id} />}
                </>
              )
            }
          ]}
        >
        </Tabs>
      </div>
    </ErrorMessageWrapper>
  );
};

export default Show;
